const initialState = {
  rowData: null,
  action: null,
};

const ltdcListRowData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ROW_DATA':
      return {
        ...state,
        rowData: action.payload.rowData,
        action: action.payload.action,
      };
    case 'RESET_ROW_DATA':
      return {
        rowData: null,
        action: null,
      };
    default:
      return state;
  }
};

export default ltdcListRowData;
